import { SUBMIT_FEEDBACK, SUBMIT_FEEDBACK_SUCCESS, SUBMIT_FEEDBACK_FAILURE } from '../../constants';
export function submitFeedback(request) {
    return {
        type: SUBMIT_FEEDBACK,
        request,
    };
}
export function submitFeedbackSuccess(result, status) {
    return {
        type: SUBMIT_FEEDBACK_SUCCESS,
        response: result,
        statuscode: status
    };
}
export function submitFeedbackError() {
    return {
        type: SUBMIT_FEEDBACK_FAILURE,
    };
}
